import { servicesApi } from '@/services/api/deprecated';
import type { SetupGuide } from '.';

export const getSetupGuide = async (environmentId: unknown) => {
  if (Number.isNaN(Number.parseFloat(environmentId as string))) {
    return null;
  }
  const { data } = await servicesApi.get<{ setup_guide: SetupGuide }>(
    `/environments/${environmentId}/setup_guide/current`,
  );
  return data;
};

export const updateSetupGuide = async (environmentId: number, setupGuide: SetupGuide) => {
  await servicesApi.put(`/environments/${environmentId}/setup_guide/current`, { setup_guide: { ...setupGuide } });
};

export const getFirstMessageData = async (environmentId: number, firstMessageId: number, firstMessageType: string) => {
  const pluralizedType = firstMessageType === 'campaign' ? 'campaigns' : 'newsletters';
  const { data } = await servicesApi.get(`/environments/${environmentId}/${pluralizedType}/${firstMessageId}`);
  return data;
};
